//-------------- IMPORTAÇÕES --------------//
import { useEffect, useContext } from "react";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { VendasContext } from "./context/VendasContext";
import { loadGroupsProductsService, loadIntegrationsService, loadReportService, loadSalesService } from "./services";
import { Main } from "./components"



//-------------- EXPORTAÇÃO DO COMPONENTE USUARIOS --------------//
export default function Usuarios() {



  //-------------- CRIAÇÃO DE HOOKS --------------//
  const { report, setReport } = useContext(VendasContext);
  const { sales, setSales } = useContext(VendasContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)
  const { search, setSearch } = useContext(VendasContext);
  const { startDateFilter, setStartDateFilter } = useContext(VendasContext);
  const { endDateFilter, setEndDateFilter } = useContext(VendasContext);
  const { statusFilter, setStatusFilter } = useContext(VendasContext);
  const { groupProductsFilter, setGroupProductsFilter } = useContext(VendasContext);
  const { groupProducts, setGroupProducts } = useContext(VendasContext);
  const { totalProductsSalesCard, setTotalProductsSalesCard } = useContext(VendasContext);
  const { totalValueCard, setTotalValueCard } = useContext(VendasContext);
  const { totalValueProducerCard, setTotalValueProducerCard } = useContext(VendasContext);
  const { totalProductsRefundedCard, setTotalProductsRefundedCard } = useContext(VendasContext);
  const { totalValueRefundedCard, setTotalValueRefundedCard } = useContext(VendasContext);
  const { integrations, setIntegrations } = useContext(VendasContext);
  const { integrationFilter, setIntegrationFilter } = useContext(VendasContext);
  const { plataformFilter, setPlatformFilter } = useContext(VendasContext);



  //-------------- USE EFFECT DE INICIALIZAÇÃO --------------//
  useEffect(() => {
    handleLoadingSales();
    handleLoadingGroupsProducts();
    handleLoadIntegrations();
    handleResetCards();
  }, []);



  //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
  // Nesta função, é requisitado à API as TAGS armazenadas.
  // AS TAGS retornadas pela API são armazenadas no Estado "tags" .
  async function handleLoadIntegrations() {
    const response = await loadIntegrationsService();
    if (response) {
      setIntegrations(response.data);
    }
  };



  //-------------- FUNÇÃO ASSÍNCRONA CARREGAR USUÁRIOS --------------//
  // Responsável por requisitar os usuário à API
  async function handleLoadingSales() {
    setIsLoading(true);
    const response = await loadSalesService(statusFilter, groupProductsFilter, startDateFilter, endDateFilter, search, integrationFilter, plataformFilter);
    if (response) {
      console.log(response.data)
      setSales(response.data.vendas);
    }
    setIsLoading(false);
  };



  //-------------- FUNÇÃO ASSÍNCRONA CARREGAR GRUPOS DE PRODUTOS --------------//
  async function handleLoadingGroupsProducts() {
    setIsLoading(true);
    const response = await loadGroupsProductsService();
    if (response) {
      setGroupProducts(response.data);
      handleLoadReport()
    }
    setIsLoading(false);
  };



  //------------ FUNÇÃO ASSÍNCRONA BUSCAR RELATÓRIO ------------//
  async function handleLoadReport() {
    const response = await loadReportService();
    if (response) {
      setReport(response.data);
    }
  };



  //--------------- FUNÇÃO HANDLE RESET CARDS ---------------//
  function handleResetCards() {
    setTotalProductsSalesCard(0);
    setTotalValueCard(0);
    setTotalValueProducerCard(0);
    setTotalProductsRefundedCard(0);
    setTotalValueRefundedCard(0);
  }



  //-------------- RETORNO CONDICIONAL DO COMPONENTE USUÁRIOS --------------//
  return (
    <>
      {isLoading || sales === null ? <Loading /> : <Main />}
    </>
  )
}